<div class="contract-view-container">
  <mat-card class="contract-card">
    <mat-card-header class="card-header">
      <div class="header-content">
        <mat-card-subtitle>
          {{ contract?.contractNumber }}
        </mat-card-subtitle>
      </div>
      <div class="header-actions">
        @if (canEdit()) {
          <button mat-flat-button color="primary" (click)="onEdit()">
            <mat-icon>edit</mat-icon>
            Editar Contrato
          </button>
        }
      </div>
    </mat-card-header>

    <mat-card-content class="card-content">
      <!-- Loading Spinner -->
      @if (isLoading) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Carregando contrato...</p>
        </div>
      }

      <!-- Contract Details -->
      @if (!isLoading && contract) {
        <div class="contract-details">
          <!-- Basic Information Section -->
          <div class="info-section">
            <h3 class="section-title">
              <mat-icon>info</mat-icon>
              Informações Básicas
            </h3>

            <div class="info-grid">
              <div class="info-item">
                <label>Número do Contrato:</label>
                <span class="info-value">{{ contract.contractNumber }}</span>
              </div>

              <div class="info-item">
                <label>Cliente:</label>
                <div class="info-value">
                  <span class="organization-name">{{
                    contract.organization.name
                  }}</span>
                  <small class="organization-cnpj">{{
                    contract.organization.cnpj | cnpj
                  }}</small>
                </div>
              </div>

              <div class="info-item">
                <label>Período:</label>
                <div class="info-value">
                  <span class="period-dates"
                    >{{ contract.startDate | date: "dd/MM/yyyy" }} -
                    {{ contract.endDate | date: "dd/MM/yyyy" }}</span
                  >
                  <small class="period-duration"
                    >{{ getPeriodDurationInDays() }} dias</small
                  >
                </div>
              </div>

              <div class="info-item">
                <label>Modalidade:</label>
                <mat-chip [class]="getModalityChipClass(contract.modality)">
                  {{ getModalityLabel(contract.modality) }}
                </mat-chip>
              </div>

              <div class="info-item">
                <label>Status:</label>
                <mat-chip [class]="getStatusChipClass()">
                  {{ getContractStatus() }}
                </mat-chip>
              </div>
            </div>
          </div>

          <!-- Quantities Section (only for with_commitment modality) -->
          @if (contract.modality === "with_commitment") {
            <div class="info-section">
              <h3 class="section-title">
                <mat-icon>assessment</mat-icon>
                Quantitativos Contratados
              </h3>

              <div class="quantities-grid">
                <div class="quantity-item">
                  <mat-icon class="quantity-icon">security</mat-icon>
                  <div class="quantity-info">
                    <label>Compliance</label>
                    <span class="quantity-value">
                      {{ contract.complianceReportsLimit || 0 | number }}
                      relatórios
                    </span>
                  </div>
                </div>

                <div class="quantity-item">
                  <mat-icon class="quantity-icon">history</mat-icon>
                  <div class="quantity-info">
                    <label>Histórico</label>
                    <span class="quantity-value">
                      {{ contract.historyReportsLimit || 0 | number }}
                      relatórios
                    </span>
                  </div>
                </div>

                <div class="quantity-item">
                  <mat-icon class="quantity-icon">monitoring</mat-icon>
                  <div class="quantity-info">
                    <label>Monitoramento</label>
                    <span class="quantity-value">
                      {{ contract.monitoringHectaresLimit || 0 | number }}
                      hectares
                    </span>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (contract.modality === "without_commitment") {
            <div class="info-section">
              <h3 class="section-title">
                <mat-icon>assessment</mat-icon>
                Produtos Contratados
              </h3>

              <div class="quantities-grid">
                @if (contract.complianceReportsLimit !== 0) {
                  <div class="quantity-item">
                    <mat-icon class="quantity-icon">security</mat-icon>
                    <div class="quantity-info">
                      <label>Compliance</label>
                    </div>
                  </div>
                }

                @if (contract.historyReportsLimit !== 0) {
                  <div class="quantity-item">
                    <mat-icon class="quantity-icon">history</mat-icon>
                    <div class="quantity-info">
                      <label>Histórico</label>
                    </div>
                  </div>
                }

                @if (contract.monitoringHectaresLimit !== 0) {
                  <div class="quantity-item">
                    <mat-icon class="quantity-icon">monitoring</mat-icon>
                    <div class="quantity-info">
                      <label>Monitoramento</label>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }

      <!-- Not Found -->
      @if (!isLoading && !contract) {
        <div class="not-found">
          <mat-icon>error</mat-icon>
          <h3>Contrato não encontrado</h3>
          <p>O contrato solicitado não foi encontrado no sistema.</p>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
